import { store } from '@/store';
import { ResourceType } from '@/types/resources';
import { createNewPageAndUpdateRoute } from '@/utilities/createNewPageAndUpdateRoute';

export const uploadFn = async (
  editorId: string,
  file: File,
  resourceType: string,
  parentResourceType: string,
  parentResourceId: string,
  id?: string,
  isModal: boolean = true
) => {
  const resourceId = store.getters.editor(editorId).resourceId;
  const formData = new FormData();
  const currentRoute = store.getters.getCurrentRoute;

  // to upload an image you need page_id, so we first need to create page and then upload an image
  if (
    resourceType === ResourceType.Page &&
    resourceId === 'newpage' &&
    currentRoute.name === 'newpage'
  ) {
    const currentPage = store.getters.getPage;
    await createNewPageAndUpdateRoute(currentPage).then((page: any) => {
      return Promise.reject({
        message: 'pageCreated',
        resourceId: page.id,
      });
    });
  }

  const resourceProperty =
    resourceType === ResourceType.Comment ? `${parentResourceType}_id` : `${resourceType}_id`;

  formData.append('files', file, file.name);
  // @ts-ignore
  formData.append('attachment', false);
  if (resourceId !== 'quick') {
    formData.append(
      resourceProperty,
      resourceType === ResourceType.Comment ? parentResourceId : resourceId
    );
  }

  return store
    .dispatch('uploadFiles', { payload: formData, id, localId: id })
    .then(({ data }: any) => {
      const route = store.getters.getRoutes.files;
      const teamId = store.getters.getTeamID;
      const dataFile = data?.files?.[0] ?? { id: '', name: '', blurhash: '' };
      const url = `${route}/v1/${teamId}/files/${dataFile.id}`;
      const { id: fileId } = dataFile;
      if (resourceId === 'quick') {
        switch (resourceType) {
          case ResourceType.Card:
            store.dispatch('addQuickCardFileToUpdate', { file: fileId, isModal });
            break;
          case ResourceType.Page:
            store.dispatch('addQuickPageFileToUpdate', fileId);
            break;
          default:
            break;
        }
      }
      return { ...dataFile, remoteFileUrl: dataFile.url, url };
    })
    .catch((err: any) => {
      throw err;
    });
};
